const ResultDocumentDetail = () => import("@/pages/modus/result/documents/ResultDocumentDetail");
const ResultIndex = () => import('@/pages/modus/result/ResultIndex');
const ResultDetail = () => import('@/pages/modus/result/ResultDetail');
const ResultSandbox = () => import("@/pages/modus/result/ResultSandbox");
const ResultSingle = () => import("@/pages/modus/result/ResultSingle");

export class ResultRoutes {

  constructor() {
    this.route_root = 'results';
    this.type_single = 'Result';
    this.type_plural = 'Results';

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          },
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            name: `List ${this.type_plural}`,
            component: ResultIndex,
            meta: { requiresAuth: true },
          },
          {
            path: ":submission_id",
            component: ResultSingle,
            children: [
              {
                path: "",
                name: `View ${this.type_single}`,
                component: ResultDetail,
                meta: { requiresAuth: true },
              },
              {
                path: "/sandbox",
                name: `${this.type_single} Sandbox`,
                component: ResultSandbox,
                meta: { requiresAuth: true },
              },
              {
                path: "/documents/:result_document_id",
                name: "View Document",
                component: ResultDocumentDetail,
                meta: { requiresAuth: true },
              },
            ],
          },
        ],
      },
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}

